(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      // every search in the header (modal + inline desktop): the first one alone was the modal's (UX-050)
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (Array.prototype.some.call(this.predictiveSearches, (search) => search.isOpen)) return;
      

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hk-contact-page"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.getElementById('hk-contact');
  if (!root) return;

  /* ── Live open/closed status ──
     The top bar's schedule is the one source (window.HKTopbar.status(): weekly hours, special days,
     Europe/Chisinau; ARCH-032). It loads after this script, so ask once the deferred scripts ran.
     This section's own hour settings are only the fallback for a page without that schedule. */
  var statusEl = root.querySelector('[data-hk-status]');
  function ownHoursOpen() {
    var d = statusEl.dataset;
    var parts = new Intl.DateTimeFormat('en-US', { timeZone: 'Europe/Chisinau', hour: 'numeric', hourCycle: 'h23', weekday: 'short' }).formatToParts(new Date());
    var weekday = parts.find(function (p) { return p.type === 'weekday'; }).value;
    var hour = parseInt(parts.find(function (p) { return p.type === 'hour'; }).value, 10);
    if (['Mon', 'Tue', 'Wed', 'Thu', 'Fri'].indexOf(weekday) > -1) return hour >= parseInt(d.monFriOpen, 10) && hour < parseInt(d.monFriClose, 10);
    if (weekday === 'Sat') return hour >= parseInt(d.satOpen, 10) && hour < parseInt(d.satClose, 10);
    return false;
  }
  function renderStatus() {
    try {
      var shared = window.HKTopbar && window.HKTopbar.status ? window.HKTopbar.status() : null;
      var isOpen = shared ? shared.open : ownHoursOpen();
      var T = window.HK_CONTACT_I18N || {};
      var textEl = statusEl.querySelector('[data-hk-status-text]');
      var noteEl = statusEl.querySelector('[data-hk-status-note]');
      statusEl.classList.toggle('is-open', isOpen);
      statusEl.classList.toggle('is-closed', !isOpen);
      textEl.textContent = (isOpen ? T.statusOpen : T.statusClosed) || textEl.textContent;
      noteEl.textContent = (isOpen ? T.noteOpen : T.noteClosed) || '';
    } catch (e) { /* status is decorative; never block the page */ }
    statusEl.classList.remove('is-loading');
  }
  if (statusEl) {
    if (window.HKTopbar || document.readyState === 'complete') renderStatus();
    else document.addEventListener('DOMContentLoaded', renderStatus, { once: true });
  }

  /* ── Department tabs ── */
  var tabs = root.querySelectorAll('[data-hk-tab]');
  var extras = root.querySelectorAll('[data-hk-extra]');
  var deptField = root.querySelector('[data-hk-department-field]');
  var subjectField = root.querySelector('[data-hk-subject-field]');
  var deptLabels = { sales: 'Vânzări', service: 'Service', parts: 'Piese', rental: 'Închiriere' };

  function trackContactLead(email, phone) {
  try {
    if (typeof window.gtag === 'function') {
      // Only with marketing consent (null otherwise); phone normalised to E.164.
      var userData = typeof window.hkLeadUserData === 'function' ? window.hkLeadUserData(email, phone) : null;
      if (userData) window.gtag('set', 'user_data', userData);
      window.gtag('event', 'generate_lead', { currency: 'MDL', form_type: 'contact' });
    }
    if (typeof window.fbq === 'function') window.fbq('track', 'Lead');
  } catch (e) { /* analytics should never block or break the success flow */ }
}
  function setDepartment(key) {
    tabs.forEach(function (t) {
      var active = t.dataset.hkTab === key;
      t.classList.toggle('is-active', active);
      t.setAttribute('aria-checked', active ? 'true' : 'false');
      t.tabIndex = active ? 0 : -1;
    });
    extras.forEach(function (el) {
      el.hidden = el.dataset.hkExtra !== key;
    });
    if (deptField) deptField.value = deptLabels[key] || key;
    if (subjectField) subjectField.value = '[' + (deptLabels[key] || key) + '] Cerere de contact — HandlerKraft';
  }

  tabs.forEach(function (t, i) {
    t.addEventListener('click', function () { setDepartment(t.dataset.hkTab); });
    /* radio group keys: arrows move and select (wrapping), Home / End jump to the ends */
    t.addEventListener('keydown', function (e) {
      var n = tabs.length, to = -1;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') to = (i + 1) % n;
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') to = (i - 1 + n) % n;
      else if (e.key === 'Home') to = 0;
      else if (e.key === 'End') to = n - 1;
      if (to < 0) return;
      e.preventDefault();
      setDepartment(tabs[to].dataset.hkTab);
      tabs[to].focus();
    });
  });
  setDepartment('sales');

  /* Name and phone are no longer filtered as you type (characters vanished silently); their
     pattern is checked on submit and explained inline below the field (A11Y-013). */

  /* ── Message field ──
     Links and one-word messages are allowed (buyers paste product URLs or ask "CPCD25?").
     Only a message shorter than 3 characters is rejected. A link to another site tags the
     e-mail subject so staff can spot spam; links to this shop are not flagged. */
  var MIN_MESSAGE_CHARS = 3;
  function hasForeignLink(v) {
    return (String(v || '').match(/(?:https?:\/\/|www\.)[^\s]+/gi) || []).some(function (u) {
      var host = u.replace(/^https?:\/\//i, '').split(/[\/?#:]/)[0].toLowerCase();
      return !(host === location.hostname || /(^|\.)handlerkraft\.md$/.test(host) || /\.myshopify\.com$/.test(host));
    });
  }
  function validateMessage(msgField) {
    var val = msgField.value.trim();
    var errorText = (window.HK_CONTACT_I18N && window.HK_CONTACT_I18N.errorMessage) || '';
    if (val.length > 0 && val.length < MIN_MESSAGE_CHARS) {
      msgField.setCustomValidity(errorText);
      return false;
    }
    msgField.setCustomValidity('');
    return true;
  }

  /* ── Form submit (Web3Forms) ── */
  var form = root.querySelector('[data-hk-form]');
  if (form) {
    var submitBtn = form.querySelector('[data-hk-submit]');
    var submitLabel = form.querySelector('[data-hk-submit-label]');
    var msgEl = form.querySelector('[data-hk-form-msg]');
    var messageField = form.querySelector('#hk-contact-message');
    var defaultLabel = submitLabel.textContent;
    var sendingLabel = (window.HK_CONTACT_I18N && window.HK_CONTACT_I18N.submitting) || defaultLabel;
    var successMsg = (window.HK_CONTACT_I18N && window.HK_CONTACT_I18N.success) || 'Mulțumim! Mesajul a fost trimis.';
    var errorMsg = (window.HK_CONTACT_I18N && window.HK_CONTACT_I18N.error) || 'A apărut o eroare. Te rugăm să ne suni direct.';
    var orWord = (window.HK_CONTACT_I18N && window.HK_CONTACT_I18N.or) || 'sau';
    var REQUEST_TIMEOUT_MS = 15000;

    /* Error text + tel / WhatsApp links, so a failed send always leaves a direct path. */
    function showError() {
      msgEl.textContent = errorMsg + ' ';
      var tel = form.getAttribute('data-tel'), wa = form.getAttribute('data-wa');
      if (tel) {
        var a = document.createElement('a');
        a.href = 'tel:' + tel;
        a.textContent = form.getAttribute('data-tel-display') || tel;
        msgEl.appendChild(a);
      }
      if (wa) {
        if (tel) msgEl.appendChild(document.createTextNode(' ' + orWord + ' '));
        var w = document.createElement('a');
        w.href = 'https://wa.me/' + wa;
        w.target = '_blank';
        w.rel = 'noopener';
        w.textContent = 'WhatsApp';
        msgEl.appendChild(w);
      }
      if (tel || wa) msgEl.appendChild(document.createTextNode('.'));
      msgEl.classList.add('is-error');
    }

    if (messageField) {
      messageField.addEventListener('input', function () { validateMessage(messageField); });
    }

    /* ── Inline field errors (A11Y-013): persistent text under the field, tied to it with
       aria-describedby + aria-invalid, in the page language (not the browser's bubble) ── */
    var T = window.HK_CONTACT_I18N || {};
    /* name / phone / e-mail: the shared lead-form rules (assets/hk-validate.js, ARCH-023) */
    var checked = [
      { el: form.querySelector('#hk-contact-name'), bad: T.errorName, ok: function (v) { return window.HKValidate.name(v); } },
      { el: form.querySelector('#hk-contact-phone'), bad: T.errorPhone, ok: function (v) { return window.HKValidate.phone(v).ok; } },
      { el: form.querySelector('#hk-contact-email'), bad: T.errorEmail, ok: function (v) { return window.HKValidate.email(v); } },
      { el: messageField, bad: T.errorMessage }
    ].filter(function (f) { return f.el; });

    function fieldError(f) {
      var v = f.el.validity;
      if (v.valueMissing) return T.errorRequired || f.el.validationMessage;
      if (f.ok && !f.ok(f.el.value)) return f.bad || f.el.validationMessage;
      if (v.valid) return '';
      return f.bad || f.el.validationMessage;
    }
    function paint(f, text) {
      var err = document.getElementById(f.el.id + '-err');
      if (text) f.el.setAttribute('aria-invalid', 'true');
      else f.el.removeAttribute('aria-invalid');
      if (err) { err.textContent = text; err.hidden = !text; }
    }
    /* returns the first invalid field, or null */
    function showFieldErrors() {
      var first = null;
      checked.forEach(function (f) {
        var text = fieldError(f);
        paint(f, text);
        if (text && !first) first = f.el;
      });
      return first;
    }
    checked.forEach(function (f) {
      /* once a field has been flagged, re-check it as the visitor corrects it */
      f.el.addEventListener('input', function () {
        if (f.el.getAttribute('aria-invalid') === 'true') paint(f, fieldError(f));
      });
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      // Honeypot ticked → a bot (or a stray click): show the usual success, send nothing.
      if (form.querySelector('.hk-contact__honeypot').checked) {
        msgEl.textContent = successMsg;
        msgEl.classList.remove('is-error');
        msgEl.classList.add('is-success');
        return;
      }

      if (messageField) validateMessage(messageField);
      var firstInvalid = showFieldErrors();
      if (firstInvalid) {
        firstInvalid.focus();
        return;
      }

      if (subjectField) {
        subjectField.value = subjectField.value.replace(/^\[conține link\] /, '');
        if (messageField && hasForeignLink(messageField.value)) subjectField.value = '[conține link] ' + subjectField.value;
      }

      submitBtn.disabled = true;
      submitLabel.textContent = sendingLabel;
      msgEl.textContent = '';
      msgEl.classList.remove('is-success', 'is-error');

      // Never leave the button on "sending": abort after REQUEST_TIMEOUT_MS.
      var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
      var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, REQUEST_TIMEOUT_MS) : null;

      fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form),
        signal: ctrl ? ctrl.signal : undefined
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          clearTimeout(timer);
          submitBtn.disabled = false;
          submitLabel.textContent = defaultLabel;
          if (data && data.success) {
            msgEl.textContent = successMsg;
            msgEl.classList.add('is-success');
            trackContactLead(
              (form.querySelector('#hk-contact-email') || {}).value,
              (form.querySelector('#hk-contact-phone') || {}).value
            );
            form.reset();
            setDepartment('sales');
          } else {
            showError();
          }
        })
        .catch(function () {
          clearTimeout(timer);
          submitBtn.disabled = false;
          submitLabel.textContent = defaultLabel;
          showError();
        });
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hk-rental"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var NAME_STRIP = /[0-9_@#$%^&*=+<>{}\[\]\\|~`"/;:!?]/g;
  var PHONE_STRIP = /[^0-9+()\-\s]/g;
  var URL_RE = /(?:https?:\/\/|www\.)[^\s]+/gi;
  /* Links are allowed (buyers paste product URLs). A link to another site only tags the e-mail
     subject so staff can spot spam; links to this shop are not flagged. */
  function hasForeignLink(v) {
    return (String(v || '').match(URL_RE) || []).some(function (u) {
      var host = u.replace(/^https?:\/\//i, '').split(/[\/?#:]/)[0].toLowerCase();
      return !(host === location.hostname || /(^|\.)handlerkraft\.md$/.test(host) || /\.myshopify\.com$/.test(host));
    });
  }
  var MIN_FILL_MS = 3000;

  function readI18n(root) {
    var el = root.querySelector('[data-hk-i18n]');
    if (!el) return {};
    // `| t` HTML-escapes apostrophes/quotes and `| json` keeps the entity; decode for textContent (UX-042)
    try { return JSON.parse(el.textContent, function (k, v) { return typeof v === 'string' ? v.replace(/&(#39|#x27|quot|amp|lt|gt);/g, function (m, e) { return { '#39': "'", '#x27': "'", quot: '"', amp: '&', lt: '<', gt: '>' }[e]; }) : v; }); } catch (e) { return {}; }
  }

  function chisinauNow() {
    var parts = new Intl.DateTimeFormat('en-US', {
      timeZone: 'Europe/Chisinau', weekday: 'short', hour: 'numeric', minute: 'numeric',
      year: 'numeric', month: '2-digit', day: '2-digit', hourCycle: 'h23'
    }).formatToParts(new Date());
    var o = {};
    parts.forEach(function (p) { o[p.type] = p.value; });
    return {
      weekday: o.weekday,
      minutes: parseInt(o.hour, 10) * 60 + parseInt(o.minute, 10),
      isoDate: o.year + '-' + o.month + '-' + o.day
    };
  }

  /* ── Live open/closed status ──
     The top bar's schedule is the one source (window.HKTopbar.status(): weekly hours, special days;
     ARCH-032). It loads after this script, so ask once the deferred scripts ran. The section's own
     hour settings are only the fallback for a page without that schedule. */
  function initStatus(root, t) {
    var el = root.querySelector('[data-hk-status]');
    if (!el) return;
    function render() {
      try {
        var shared = window.HKTopbar && window.HKTopbar.status ? window.HKTopbar.status() : null;
        var open = false;
        if (shared) {
          open = shared.open;
        } else {
          var now = chisinauNow();
          var d = el.dataset;
          if (['Mon', 'Tue', 'Wed', 'Thu', 'Fri'].indexOf(now.weekday) > -1) {
            open = now.minutes >= d.wkOpen * 60 && now.minutes < d.wkClose * 60;
          } else if (now.weekday === 'Sat') {
            open = now.minutes >= d.satOpen * 60 && now.minutes < d.satClose * 60;
          }
        }
        el.classList.toggle('is-open', open);
        el.classList.toggle('is-closed', !open);
        var txt = el.querySelector('[data-hk-status-text]');
        if (txt) txt.textContent = open ? (t.statusOpen || txt.textContent) : (t.statusClosed || '');
      } catch (e) { /* status is decorative; never block the page */ }
      el.classList.remove('is-loading');
    }
    if (window.HKTopbar || document.readyState === 'complete') render();
    else document.addEventListener('DOMContentLoaded', render, { once: true });
  }

  /* ── Row CTA → prefill the form ── */
  function initPrefill(root) {
    var form = root.querySelector('[data-hk-form]');
    if (!form) return;
    var capacity = form.querySelector('[data-hk-capacity]');
    var fuels = form.querySelectorAll('[data-hk-fuel]');
    var nameInput = form.querySelector('[data-hk-v="name"]');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    root.querySelectorAll('[data-hk-prefill]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var cap = btn.getAttribute('data-capacity');
        var fuel = btn.getAttribute('data-fuel');
        if (capacity && cap) {
          for (var i = 0; i < capacity.options.length; i++) {
            if (capacity.options[i].value === cap) { capacity.selectedIndex = i; break; }
          }
        }
        if (fuel) {
          fuels.forEach(function (r) { r.checked = r.value === fuel; });
        }
        var target = root.querySelector('#hk-rental-quote') || form;
        target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        if (nameInput) {
          setTimeout(function () { nameInput.focus({ preventScroll: true }); }, reduce ? 0 : 450);
        }
      });
    });
  }

  /* ── Quote form ── */
  function initForm(root, t) {
    var form = root.querySelector('[data-hk-form]');
    if (!form) return;

    var renderedAt = Date.now();
    var submitBtn = form.querySelector('[data-hk-submit]');
    var submitLabel = form.querySelector('[data-hk-submit-label]');
    var defaultLabel = submitLabel ? submitLabel.textContent : '';
    var msg = form.querySelector('[data-hk-msg]');
    var subject = form.querySelector('[data-hk-subject]');
    var baseSubject = subject ? subject.value : '';
    var page = form.querySelector('[data-hk-page]');
    if (page) page.value = window.location.href.split('#')[0];

    var today = '';
    try { today = chisinauNow().isoDate; } catch (e) { today = new Date().toISOString().slice(0, 10); }
    var dateInput = form.querySelector('[data-hk-v="date"]');
    if (dateInput) dateInput.min = today;

    /* No-JS fallback redirect lands here with ?trimis=1 */
    if (/[?&]trimis=1\b/.test(window.location.search) && msg) {
      setMsg('success', t.success);
    }

    function setMsg(kind, text) {
      if (!msg) return;
      msg.className = 'hk-rental__msg' + (kind ? ' is-' + kind : '');
      msg.textContent = text || '';
    }

    function fieldWrap(el) { return el.closest('.hk-rental__field'); }

    function setError(el, text) {
      var wrap = fieldWrap(el);
      var err = document.getElementById(el.getAttribute('aria-describedby'));
      if (text) {
        if (wrap) wrap.classList.add('is-invalid');
        el.setAttribute('aria-invalid', 'true');
        if (err) err.textContent = text;
      } else {
        if (wrap) wrap.classList.remove('is-invalid');
        el.removeAttribute('aria-invalid');
        if (err) err.textContent = '';
      }
    }

    /* name / phone / e-mail: the shared lead-form rules (assets/hk-validate.js, ARCH-023) */
    var rules = {
      name: function (v) {
        return window.HKValidate.name(v) ? '' : t.errorName;
      },
      phone: function (v) {
        return window.HKValidate.phone(v).ok ? '' : t.errorPhone;
      },
      email: function (v) {
        v = v.trim();
        return (!v || window.HKValidate.email(v)) ? '' : t.errorEmail;
      },
      duration: function (v) { return v ? '' : t.errorDuration; },
      date: function (v) { return (!v || !today || v >= today) ? '' : t.errorDate; }
    };

    function validate(el) {
      var rule = rules[el.getAttribute('data-hk-v')];
      if (!rule) return true;
      var problem = rule(el.value || '');
      setError(el, problem);
      return !problem;
    }

    var fields = Array.prototype.slice.call(form.querySelectorAll('[data-hk-v]'));

    fields.forEach(function (el) {
      var kind = el.getAttribute('data-hk-v');
      el.addEventListener('blur', function () {
        if (el.value || el.hasAttribute('data-hk-touched')) validate(el);
        el.setAttribute('data-hk-touched', '');
      });
      el.addEventListener(el.tagName === 'SELECT' ? 'change' : 'input', function () {
        if (kind === 'name' || kind === 'phone') {
          var re = kind === 'name' ? NAME_STRIP : PHONE_STRIP;
          var before = el.value;
          var pos = el.selectionStart;
          var clean = before.replace(re, '');
          if (clean !== before) {
            el.value = clean;
            if (pos !== null) {
              var p = Math.max(0, pos - (before.length - clean.length));
              try { el.setSelectionRange(p, p); } catch (e) {}
            }
          }
        }
        if (el.getAttribute('aria-invalid') === 'true' || el.tagName === 'SELECT') validate(el);
      });
    });

    function trackLead(phone, email) {
      try {
        if (typeof window.gtag === 'function') {
          // Only with marketing consent (null otherwise); phone normalised to E.164.
          var ud = typeof window.hkLeadUserData === 'function' ? window.hkLeadUserData(email, phone) : null;
          if (ud) window.gtag('set', 'user_data', ud);
          window.gtag('event', 'generate_lead', { form_type: 'rental', currency: 'EUR' });
        }
        if (typeof window.fbq === 'function') window.fbq('track', 'Lead', { content_category: 'rental' });
      } catch (e) { /* analytics must never break the form */ }
    }

    function busy(on) {
      if (!submitBtn) return;
      submitBtn.disabled = on;
      if (submitLabel) submitLabel.textContent = on ? (t.submitting || defaultLabel) : defaultLabel;
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      setMsg('', '');

      var hp = form.querySelector('.hk-rental__hp');
      if (hp && hp.checked) { setMsg('success', t.success); form.reset(); return; }

      var firstBad = null;
      fields.forEach(function (el) {
        if (!validate(el) && !firstBad) firstBad = el;
      });
      if (firstBad) {
        setMsg('error', t.errorSummary);
        firstBad.focus();
        return;
      }

      if (Date.now() - renderedAt < MIN_FILL_MS) { setMsg('error', t.error); return; }

      var cap = form.querySelector('[data-hk-capacity]');
      var dur = form.querySelector('[data-hk-v="duration"]');
      if (subject) {
        var bits = [];
        if (cap && cap.value) bits.push(cap.value);
        if (dur && dur.value) bits.push(dur.value);
        subject.value = baseSubject + (bits.length ? ' — ' + bits.join(', ') : '');
        var msgField = form.querySelector('[data-hk-v="message"]');
        if (msgField && hasForeignLink(msgField.value)) subject.value = '[conține link] ' + subject.value;
      }

      var data = new FormData(form);
      data.delete('redirect');
      data.append('Timp completare (s)', String(Math.round((Date.now() - renderedAt) / 1000)));

      busy(true);
      var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
      var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, 15000) : null;

      fetch(form.action, {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: data,
        signal: ctrl ? ctrl.signal : undefined
      })
        .then(function (r) { return r.json().catch(function () { return { success: false }; }); })
        .then(function (res) {
          if (timer) clearTimeout(timer);
          busy(false);
          if (res && res.success) {
            var phoneEl = form.querySelector('[data-hk-v="phone"]');
            var emailEl = form.querySelector('[data-hk-v="email"]');
            trackLead(phoneEl && phoneEl.value.trim(), emailEl && emailEl.value.trim());
            form.reset();
            fields.forEach(function (el) { setError(el, ''); el.removeAttribute('data-hk-touched'); });
            if (subject) subject.value = baseSubject;
            renderedAt = Date.now();
            setMsg('success', t.success);
          } else {
            setMsg('error', t.error);
          }
        })
        .catch(function () {
          if (timer) clearTimeout(timer);
          busy(false);
          setMsg('error', t.error);
        });
    });
  }

  function init(root) {
    if (!root || root.hasAttribute('data-hk-ready')) return;
    root.setAttribute('data-hk-ready', '');
    var t = readI18n(root);
    initStatus(root, t);
    initPrefill(root);
    initForm(root, t);
  }

  function boot() {
    document.querySelectorAll('[data-hk-rental]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target && e.target.querySelector('[data-hk-rental]');
    if (r) init(r);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scrolling-logos"] && !Shopify.designMode) return;
  try {
    
(() => {
  const SELECTOR = '[data-hk-marquee]';

  function waitImages(container, timeoutMs = 300) {
    return new Promise(resolve => {
      const imgs = Array.from(container.querySelectorAll('img'));
      if (!imgs.length) return resolve();
      let done = 0;
      const finish = () => { done += 1; if (done >= imgs.length) resolve(); };
      setTimeout(resolve, timeoutMs);
      imgs.forEach(img => {
        if (img.complete) return finish();
        img.addEventListener('load', finish, { once: true });
        img.addEventListener('error', finish, { once: true });
      });
    });
  }

  async function build(section) {
  if (section.dataset.initialized === 'pending') return;
  section.dataset.initialized = 'pending';
  const track    = section.querySelector('[data-hk-track]');
    const template = section.querySelector('[data-hk-template]');
    const viewport = section.querySelector('[data-hk-viewport]');
    const skeleton = section.querySelector('[data-hk-skeleton]');
    if (!track || !template || !viewport) return;


    track.querySelectorAll('.hk-logos__marquee').forEach(n => n.remove());

    const baseItems = Array.from(template.children).filter(Boolean);
    if (!baseItems.length) return;

    const marquee = document.createElement('div');
    marquee.className = 'hk-logos__marquee';

    const g1 = document.createElement('div');
    g1.className = 'hk-logos__group';

    const g2 = document.createElement('div');
    g2.className = 'hk-logos__group';
    g2.setAttribute('aria-hidden', 'true');

    const appendSet = (group) => {
      baseItems.forEach(node => {
        const clone = node.cloneNode(true);
        if (clone.tagName === 'A') clone.setAttribute('tabindex', '0');
        group.appendChild(clone);
      });
    };

    appendSet(g1);
    marquee.appendChild(g1);
    marquee.appendChild(g2);
    track.appendChild(marquee);

    await waitImages(marquee, 300);

    const viewportW = Math.max(1, viewport.clientWidth);

    let loops = 0;
    while (g1.scrollWidth < viewportW * 1.4 && loops < 14) {
      appendSet(g1);
      loops += 1;
    }

    g2.innerHTML = '';
    Array.from(g1.children).forEach(child => {
      const clone = child.cloneNode(true);
      if (clone.tagName === 'A') clone.setAttribute('tabindex', '0');
      g2.appendChild(clone);
    });

    const direction = section.dataset.direction || 'left';
    section.style.setProperty('--hk-dir', direction === 'right' ? 'reverse' : 'normal');

    const shift = Math.max(1, g1.scrollWidth);
    section.style.setProperty('--hk-shift', `${shift}px`);

    const baseSpeed  = parseFloat(section.style.getPropertyValue('--hk-speed')) || 60;
    const pxPerSec   = Math.max(30, viewportW / Math.max(10, baseSpeed));
    const duration   = shift / pxPerSec;
    section.style.setProperty('--hk-duration', `${duration.toFixed(2)}s`);

    setupKeyboardNav(viewport);
    setupTouchGestures(viewport, marquee);
    setupAnalytics(section);
    setupToggle(section);



    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        section.setAttribute('data-initialized', 'true'); // skeleton fades OUT
        marquee.style.opacity = '1';                      // logos fade IN
        // both happen at the same time = clean crossfade
        if (skeleton) {
          setTimeout(() => { skeleton.style.display = 'none'; }, 400);
        }
      });
    });
  }
  
  

  function setupKeyboardNav(viewport) {
    viewport.addEventListener('keydown', (e) => {
      const focusable = Array.from(viewport.querySelectorAll('.hk-logos__item[href]'));
      const idx = focusable.indexOf(document.activeElement);
      if (e.key === 'ArrowRight' && idx < focusable.length - 1) { e.preventDefault(); focusable[idx + 1].focus(); }
      else if (e.key === 'ArrowLeft' && idx > 0)               { e.preventDefault(); focusable[idx - 1].focus(); }
      else if (e.key === 'Home' && focusable.length)            { e.preventDefault(); focusable[0].focus(); }
      else if (e.key === 'End'  && focusable.length)            { e.preventDefault(); focusable[focusable.length - 1].focus(); }
    });
  }

  function setupTouchGestures(viewport, marquee) {
    let startX = 0, isPaused = false;
    viewport.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; }, { passive: true });
    viewport.addEventListener('touchmove', (e) => {
      if (Math.abs(e.touches[0].clientX - startX) > 10 && !isPaused) {
        marquee.style.animationPlayState = 'paused';
        isPaused = true;
      }
    }, { passive: true });
    viewport.addEventListener('touchend', () => {
      if (isPaused) {
        setTimeout(() => { marquee.style.animationPlayState = 'running'; isPaused = false; }, 300);
      }
    }, { passive: true });
  }

  /* Stop / start button (WCAG 2.2.2). The choice is remembered and shared with the hero slideshow. */
  const MOTION_KEY = 'hk-motion-paused';
  function setupToggle(section) {
    const btn = section.querySelector('[data-hk-logos-toggle]');
    if (!btn) return;
    const apply = (paused) => {
      section.classList.toggle('hk-logos--paused', paused);
      btn.setAttribute('aria-label', btn.getAttribute(paused ? 'data-label-play' : 'data-label-pause'));
    };
    if (!btn.dataset.bound) {
      btn.dataset.bound = '1';
      btn.addEventListener('click', () => {
        const paused = !section.classList.contains('hk-logos--paused');
        try { localStorage.setItem(MOTION_KEY, paused ? '1' : '0'); } catch (e) { /* storage blocked */ }
        apply(paused);
      });
    }
    let stored = false;
    try { stored = localStorage.getItem(MOTION_KEY) === '1'; } catch (e) { /* storage blocked */ }
    apply(stored);
    btn.hidden = false;
  }

  function setupAnalytics(section) {
    section.querySelectorAll('.hk-logos__item[href]').forEach((logo, index) => {
      logo.addEventListener('click', () => {
        if (window.dataLayer) {
          window.dataLayer.push({ event: 'logo_click', logo_index: index, logo_href: logo.href, logo_alt: logo.getAttribute('aria-label') });
        }
        if (window.ShopifyAnalytics) {
          window.ShopifyAnalytics.lib.track('Logo Clicked', { index, url: logo.href });
        }
      });
    });
  }

  function observeSections() {
    if (!('IntersectionObserver' in window)) { initAll(); return; }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && entry.target.dataset.initialized === 'false') {
          build(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '300px' });
    document.querySelectorAll(SELECTOR).forEach(s => {
      if (s.dataset.initialized === 'false') observer.observe(s);
    });
  }

  function initAll(root = document) {
    root.querySelectorAll(SELECTOR).forEach(s => build(s));
  }

  function setupVisibilityHandler() {
    document.addEventListener('visibilitychange', () => {
      document.querySelectorAll('.hk-logos__marquee').forEach(m => {
        m.style.animationPlayState = document.hidden ? 'paused' : 'running';
      });
    });
  }

  let resizeRAF = null, lastWidth = window.innerWidth;
  function handleResize() {
    const w = window.innerWidth;
    if (w === lastWidth) return;
    lastWidth = w;
    if (resizeRAF) return;
    resizeRAF = requestAnimationFrame(() => { initAll(); resizeRAF = null; });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => { observeSections(); setupVisibilityHandler(); });
  } else {
    observeSections();
    setupVisibilityHandler();
  }

  window.addEventListener('load', () => {
  document.querySelectorAll(SELECTOR).forEach(s => {
    if (s.dataset.initialized === 'false') build(s);
  });
});
  window.addEventListener('resize', handleResize);

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (e) => initAll(e.target));
    document.addEventListener('shopify:section:reorder', () => initAll());
    document.addEventListener('shopify:block:select', (e) => { const s = e.target.closest(SELECTOR); if (s) build(s); });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
